import React from 'react';
import './order-note-display.scss';
import { isEmpty } from 'lodash';
import { convertSchemaToFields, SchemaFields } from '@zonofi/zono-money-store';
import { useOrderNote } from '../use-order-note';
import { getShippingAddress } from '../helpers';

interface OrderNoteDisplayProps {
  orderNoteData: Record<string, any>;
  onUpdateOrderNotes?: (orderNotesData: Record<string, any>) => void;
  status?: string;
  customerId?: string;
  shippingAddress?: any;
}
export const OrderNoteDisplay: React.FC<OrderNoteDisplayProps> = ({
  orderNoteData,
  onUpdateOrderNotes = () => {},
  status = '',
  customerId = '',
  shippingAddress = {},
}) => {
  const { orderNoteFromEditor } = useOrderNote();

  const orderNotes =
    orderNoteData ??
    (convertSchemaToFields(orderNoteFromEditor) as Record<string, any>);

  return !isEmpty(orderNotes) ? (
    <div className="order-note-display">
      {Object.entries(orderNotes)?.map(([key, value], idx) => {
        const required =
          convertSchemaToFields(orderNoteFromEditor)[key as keyof SchemaFields]
            ?.required || false;
        return (
          <div className="order-note-display-item" key={idx}>
            <span className="order-note-display-item-key font-semibold">
              {key}
              {/* {required && <span className="required font-regular">*</span>} : */}
            </span>{' '}
            <span className="order-note-display-item-value font-regular">
              {typeof value === 'object' ? '-' : value}
            </span>
          </div>
        );
      })}
      <div className="order-note-display-address">
        <span className="order-note-display-address-key font-semibold seller-font-size-medium">
          Address
        </span>
        <span className="order-note-display-address-string font-regular seller-font-size-regular">
          {!isEmpty(shippingAddress) ? (
            <>
              {getShippingAddress(shippingAddress)?.length > 0 && (
                <span className="font-regular">
                  {getShippingAddress(shippingAddress)}
                </span>
              )}
              <span className="font-regular">
                Latitude: {shippingAddress?.latitude || '-'}
              </span>
              <span className="font-regular">
                Longitude: {shippingAddress?.longitude || '-'}
              </span>
            </>
          ) : (
            '-'
          )}
        </span>
      </div>
    </div>
  ) : (
    <div className="order-note-display">
      <span className="order-note-display-empty font-regular">
        No order notes found
      </span>
    </div>
  );
};
